<template>
    <layout-authenticated show-product-type-filters>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('products.products') }}</h1>
        <products-component/>
    </layout-authenticated>
</template>

<script>
import ProductsComponent from "@/components/user/products/ProductsComponent";
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: 'Products',
    components: {LayoutAuthenticated, ProductsComponent},
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('products.products'),
                    href: '/products',
                    disabled: true
                }
            ];
        }
    }
}
</script>
